import styled from 'styled-components';
import Select from '@mui/material/Select';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledSelect = styled(Select)`
  color: ${({ theme }) => theme.palette.primary.main};

  .MuiSelect-select.MuiInputBase-input {
    padding: 4px 24px 4px 4px;
  }

  &:after {
    display: none;
  }

  &:before {
    display: none;
  }

  svg {
    fill: ${({ theme }) => theme.palette.primary.main};
  }
`;
